// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGPanIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  cursor: "pointer",
  display: "block"
};

export default class SVGPanIcon extends PureComponent<ISVGPanIconProps, {}> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.348,6.973c0,2.936,0,5.874,0,8.809c2.883,0,5.768,0,8.652,0
	c-0.006-0.866-0.01-1.85,0.078-2.595c0.243-0.162,0.23-0.271,0.63-0.314c0.444-0.234,1.249,0.714,1.572,0.944
	c1.587,1.124,3.329,2.134,4.72,3.461c0,0.183,0,0.367,0,0.55c-1.449,1.361-3.215,2.481-4.876,3.618
	c-0.35,0.239-1.065,1.2-1.73,0.787c-0.598-0.372-0.409-1.953-0.394-2.911c-2.884,0-5.769,0-8.652,0c0,2.884,0,5.769,0,8.652
	c0.941-0.012,2.046-0.024,2.753,0.157c0.503,1.043-0.362,1.581-0.866,2.281c-1.108,1.542-2.084,3.208-3.382,4.562
	c-0.158,0-0.314,0-0.472,0c-1.284-1.283-2.232-2.908-3.304-4.404c-0.465-0.649-1.158-1.032-1.179-2.124
	c0.063-0.08,0.027-0.021,0.078-0.157c0.138-0.085,0.284-0.198,0.394-0.314c0.839,0,1.677,0,2.517,0c0-2.884,0-5.768,0-8.652
	c-2.962,0-5.925,0-8.888,0c0.028,0.899,0.222,2.539-0.394,2.833c-0.15,0.139-0.247,0.149-0.55,0.157
	C4.125,20.702,1.812,19.546,0,17.827c0-0.183,0-0.367,0-0.55c1.26-1.159,2.758-2.058,4.168-3.067
	c0.756-0.542,1.333-1.374,2.438-1.337c0.492,0.749,0.407,1.654,0.394,2.91c2.962,0,5.925,0,8.888,0c0-2.936,0-5.873,0-8.809
	c-0.951,0.012-2.03,0.011-2.753-0.157c-0.067-0.114-0.142-0.225-0.235-0.314c-0.005-1.162,0.841-1.669,1.337-2.36
	c1.009-1.403,1.899-2.921,3.066-4.168c0.184,0,0.367,0,0.551,0c1.218,1.307,2.169,2.852,3.224,4.326
	c0.569,0.794,1.394,1.23,1.102,2.438C21.466,6.953,20.386,6.976,19.348,6.973z"
        />
      </svg>
    );
  }
}
